module.exports = __webpack_public_path__ + "static/media/2_image4.e8e8b023.jpg";